// extracted by mini-css-extract-plugin
export default {"leftSection":"MiniHeader_leftSection__HCxMq","rightSection":"MiniHeader_rightSection__xK93e"};